import { Button, FormControl, FormHelperText, Stack } from "@mui/material";
import { CustomTextField } from "../ui/input";
import { useTranslations } from "next-intl";
import React from "react";
import { SnackBar } from "../ui/snack-bar";
import { useTheme } from "@quales/utils/theme";
import { AppContext } from "@quales/utils/context";
import { uploadFile } from "../utils/uploadFile";
import { CustomTypographyComponent } from "../ui/text";
import RoleList from "../composites/RoleList";
import { UserRoles } from "../utils/const";

interface ContentFormProps {
  onContentDetails: (val: ContentFormState, roles: any) => void;
}

export interface ContentFormState {
  name: string;
  mimeType: string;
  downLoadURL: string;
  description?: string;
}

export const ContentForm = React.forwardRef((props: ContentFormProps, ref) => {
  const t = useTranslations();
  const { onContentDetails } = props;
  const [formIsSubmitted, setFormIsSubmitted] = React.useState(false);
  const [snackBar, setSnackBar] = React.useState(false);
  const [filedata, setFileData] = React.useState<FileList>();
  const [snackBarMessage, setSnackBarMessage] = React.useState("");
  const [severity, setSeverity] = React.useState("");

  const [selectedRoles, setSelectedRoles] = React.useState<any>();

  // const handleChange =
  //   (prop: keyof ContentFormState) =>
  //   (event: React.ChangeEvent<HTMLInputElement>) => {
  //     setValues({ ...values, [prop]: event.target.value });
  //     if (Object.keys(formErrors).includes(prop)) {
  //       if (event.target.value !== "") {
  //         formErrors[prop] = "";
  //       } else {
  //         formErrors[prop] = t("missingValues", { ns: "feedback" });
  //       }
  //       setValues({ ...values, [prop]: event.target.value });
  //     } else {
  //       setValues({ ...values, [prop]: event.target.value });
  //     }
  //     setFormErrors({ ...formErrors });
  //   };

  //   const checkRequiredValues = (val: State) => {
  //     setFormErrors({
  //       name: val.name !== "" ? "" : t("missingValues", { ns: "feedback" }),
  //       downloadURL:
  //         val.downLoadURL !== "" ? "" : t("missingValues", { ns: "feedback" }),
  //       mimeType:
  //         val.mimeType !== "" ? "" : t("missingValues", { ns: "feedback" }),
  //     });
  //   };

  const handleRoles = (rolesIDs: any[]) => {
    if (rolesIDs && rolesIDs.length > 0) {
      setSelectedRoles(rolesIDs);
    } else {
      setSelectedRoles([]);
    }
  };

  React.useImperativeHandle(ref, () => ({
    onSubmit() {
      setFormIsSubmitted(true);

      uploadFile(formData, filedata, "/files/fileUpload", "content").then(
        (res) => {
          res.length > 0 &&
            res.map((file, index) =>
              onContentDetails(
                {
                  name: file.fileName,
                  downLoadURL: file.fileID,
                  mimeType: file.mimeType,
                },
                selectedRoles
              )
            );
        }
      );
    },
  }));

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    setFileData(null);
    if (reason === "clickaway") {
      return;
    }
    setSnackBar(false);
  };

  const formData = new FormData();
  const onFileSelected = (e: React.ChangeEvent<HTMLInputElement>) => {
    //@ts-ignore
    const files: FileList = e.target.files;
    setFileData(files);
  };

  return (
    <Stack id="ContentForm" width="100%" spacing={2} padding={2}>
      <Stack spacing={2}>
        <Stack
          alignItems={"center"}
          justifyContent={"space-between"}
          spacing={2}
          direction={"row"}
          padding={2}
        >
          <CustomTypographyComponent>file(s):</CustomTypographyComponent>
          <FormControl>
            <Button
              sx={{ width: 180 }}
              variant="outlined"
              component="label"
              color={"secondary"}
            >
              {t("labels.selectFiles")}
              <input
                accept="application/pdf"
                type="file"
                hidden
                onChange={onFileSelected}
                multiple
              />
            </Button>
          </FormControl>
        </Stack>
        <Stack>
          {filedata &&
            filedata &&
            filedata.length > 0 &&
            Array.from(filedata).map((item: any, index: any) => (
              <CustomTypographyComponent key={index} variant={"body1"}>
                {item.name}
              </CustomTypographyComponent>
            ))}
        </Stack>

        <FormControl sx={{ width: "99%", marginLeft: 2 }}>
          <RoleList
            width={"100%"}
            edit={true}
            error={false}
            InputPropsValue={UserRoles}
            onValueChanged={handleRoles}
          />
          <FormHelperText>{t("common.documentRolSelectorHelp")}</FormHelperText>
        </FormControl>
      </Stack>
    </Stack>
  );
});

ContentForm.displayName = "ContentForm";

export default ContentForm;
